/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShadowComponentCriterionDetail } from './ShadowComponentCriterionDetail';
import {
    ShadowComponentCriterionDetailFromJSON,
    ShadowComponentCriterionDetailFromJSONTyped,
    ShadowComponentCriterionDetailToJSON,
    ShadowComponentCriterionDetailToJSONTyped,
} from './ShadowComponentCriterionDetail';
import type { ShadowDealbreakerFlag } from './ShadowDealbreakerFlag';
import {
    ShadowDealbreakerFlagFromJSON,
    ShadowDealbreakerFlagFromJSONTyped,
    ShadowDealbreakerFlagToJSON,
    ShadowDealbreakerFlagToJSONTyped,
} from './ShadowDealbreakerFlag';

/**
 * Optional scoring breakdown attached to clinical / financial subsystem results.
 * @export
 * @interface ShadowSubsystemScoring
 */
export interface ShadowSubsystemScoring {
    /**
     * 
     */
    insurance_score?: number;
    /**
     * 
     */
    medication_rules_score?: number;
    /**
     * 
     */
    dealbreaker_rules_score?: number;
    /**
     * 
     */
    warning_rules_score?: number;
    /**
     * 
     */
    dealbreaker_flags?: Array<ShadowDealbreakerFlag>;
    /**
     * 
     */
    component_detail?: Array<ShadowComponentCriterionDetail>;
}

/**
 * Check if a given object implements the ShadowSubsystemScoring interface.
 */
export function instanceOfShadowSubsystemScoring(value: object): value is ShadowSubsystemScoring {
    return true;
}

export function ShadowSubsystemScoringFromJSON(json: any): ShadowSubsystemScoring {
    return ShadowSubsystemScoringFromJSONTyped(json, false);
}

export function ShadowSubsystemScoringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemScoring {
    if (json == null) {
        return json;
    }
    return {
        
        'insurance_score': json['insurance_score'] == null ? undefined : json['insurance_score'],
        'medication_rules_score': json['medication_rules_score'] == null ? undefined : json['medication_rules_score'],
        'dealbreaker_rules_score': json['dealbreaker_rules_score'] == null ? undefined : json['dealbreaker_rules_score'],
        'warning_rules_score': json['warning_rules_score'] == null ? undefined : json['warning_rules_score'],
        'dealbreaker_flags': json['dealbreaker_flags'] == null ? undefined : ((json['dealbreaker_flags'] as Array<any>).map(ShadowDealbreakerFlagFromJSON)),
        'component_detail': json['component_detail'] == null ? undefined : ((json['component_detail'] as Array<any>).map(ShadowComponentCriterionDetailFromJSON)),
    };
}

export function ShadowSubsystemScoringToJSON(json: any): ShadowSubsystemScoring {
    return ShadowSubsystemScoringToJSONTyped(json, false);
}

export function ShadowSubsystemScoringToJSONTyped(value?: ShadowSubsystemScoring | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insurance_score': value['insurance_score'],
        'medication_rules_score': value['medication_rules_score'],
        'dealbreaker_rules_score': value['dealbreaker_rules_score'],
        'warning_rules_score': value['warning_rules_score'],
        'dealbreaker_flags': value['dealbreaker_flags'] == null ? undefined : ((value['dealbreaker_flags'] as Array<any>).map(ShadowDealbreakerFlagToJSON)),
        'component_detail': value['component_detail'] == null ? undefined : ((value['component_detail'] as Array<any>).map(ShadowComponentCriterionDetailToJSON)),
    };
}

